import React, { FC, useEffect, useMemo, useState } from 'react';
import { METRICS } from '@types';
import { appStore } from '@store';
import { useT } from 'hooks';
import { Title } from '../title';
import { Timer } from './components/timer';
import img1 from './img/img1.png';
import img2 from './img/img2.png';
import img1Dark from './img/img1Dark.png';
import img2Dark from './img/img2Dark.png';
import checkTheme from 'utils/custom/checkTheme';

import * as S from './styled';

export const Plan: FC = () => {
	const { surveyStore, unitsStore } = appStore;
	const units = unitsStore.isMetrics ? METRICS.KG : METRICS.LBS;
	const { answers } = surveyStore;
	const { T } = useT();
	const initialTime = 10 * 60; // 9 минут в секундах
	const [time, setTime] = useState(initialTime);
	const targetWeight = answers.ob_target_weight
		? JSON.parse(answers.ob_target_weight[0]).value
		: '65';
	const userGoal = answers.ob_goal ? answers.ob_goal[0] : 'improve_health';

	const userGoalValue = useMemo(() => {
		switch (userGoal) {
			case 'lose_weight':
				return 'Lose weight';
			case 'improve_health':
				return 'Improve health';
			case 'get_firm':
				return 'Get firm and toned';
			case 'relieve_stress':
				return 'Relieve stress';
			default:
				return 'Improve health';
		}
	}, [userGoal]);

	useEffect(() => {
		if (time > 0) {
			const timerId = setInterval(() => {
				setTime(prevTime => prevTime - 1);
			}, 1000);
			return () => clearInterval(timerId);
		}
	}, [time]);

	return (
		<S.Container>
			<Title>Your pilates workout plan is ready!</Title>
			<S.Wrapper>
				<S.Info style={{ justifyContent: 'flex-end' }}>
					{checkTheme() === 'darkMode' ? (
						<img src={img1Dark} alt='Goal' />
					) : (
						<img src={img1} alt='Goal' />
					)}
					<S.Text>
						<p>Goal</p>
						<p>{userGoalValue}</p>
					</S.Text>
				</S.Info>
				<S.Line />
				<S.Info>
					{checkTheme() === 'darkMode' ? (
						<img src={img2Dark} alt='Target weight' />
					) : (
						<img src={img2} alt='Target weight' />
					)}
					<S.Text>
						<p>Target weight</p>
						<p>
							{targetWeight} {units}
						</p>
					</S.Text>
				</S.Info>
			</S.Wrapper>
			{time ? <Timer time={time} /> : null}
		</S.Container>
	);
};
